export const mockZipCodeResponse = {
  count: 1,
  next: '',
  previous: '',
  results: [
    {
      county_name: 'Scott',
      id: 654,
      fips_county_code: '57657',
      county_code: '06019',
      zipcodes: [
        {
          lat: 42.8579471,
          lng: -73.9021788,
          code: '12008',
        },
      ],
    },
    {
      county_name: 'Pill',
      id: 234,
      fips_county_code: '23456',
      county_code: '90002',
    },
    {
      county_name: 'Los Angeles',
      id: 235,
      fips_county_code: '23457',
      county_code: 'Schenectady',
    },
    {
      county_name: 'Schenectady',
      id: 236,
      fips_county_code: '23458',
      county_code: '90001',
    },
  ],
};
